<template>
  <div class="layout">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: "query_home",
    methods: {
      handleClick() {
        this.$router.push({name: 'Home'});
      }
    }
  }
</script>

<style>
  .ivu-layout {
    background: none;
  }
  
  .ivu-upload-select {
    width: 100%;
  }
  
  .ivu-select-selection {
    border: none !important;
  }
  
  .ivu-select-visible .ivu-select-selection {
    outline: none !important;
    box-shadow: none !important;
  }
  
  .layout {
    margin: 0;
  }
  
  .title {
    font-size: 2rem;
    margin-bottom: 3rem;
    position: relative;
  }
  
  .arrow {
    position: absolute;
    left: 0;
    top: 0.6rem;
  }
  
  .hint {
    font-size: 1.5rem;
    color: #000000;
    margin-bottom: 10rem;
    margin-top: 2.8rem;
  }
  
  .btn {
    font-size: 1.5rem;
  }
  
  .text-cur {
    font-size: 1.2rem;
    color: #999999;
  }
  
  .text-act {
    font-size: 1.9rem;
    color: #f64b49;
    margin-bottom: 2rem;
    margin-top: 1.5rem;
  }
  
  .loader-overlay {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 98;
    width: 100%;
    height: 100%;
    overflow-y: hidden;
    background: rgba(0, 0, 0, 0.4);
  }
  
  .loader,
  .loader:after {
    border-radius: 50%;
    width: 80px;
    height: 80px;
  }
  
  .loader {
    margin: 0 auto;
    font-size: 10px;
    position: fixed;
    top: calc(50% - 40px);
    left: calc(50% - 40px);
    text-indent: -9999em;
    border-top: 1.1em solid rgba(255, 255, 255, 0.2);
    border-right: 1.1em solid rgba(255, 255, 255, 0.2);
    border-bottom: 1.1em solid rgba(255, 255, 255, 0.2);
    border-left: 1.1em solid #ffffff;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation: loading-animation 1.1s infinite linear;
    animation: loading-animation 1.1s infinite linear;
  }
  
  @keyframes loading-animation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  
  @-moz-keyframes loading-animation /* Firefox */
  {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  
  @-webkit-keyframes loading-animation /* Safari 和 Chrome */
  {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  
  @-o-keyframes loading-animation /* Opera */
  {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
